<main class="main-wrap">
  <section class="terms-page">
    <div class="banner-section">
      <!-- <div class="image-bg">
        <svg
          width="541"
          height="449"
          viewBox="0 0 541 449"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M296.143 364.467C299.421 364.679 302.718 364.821 306.032 364.893L306.022 365.393C307.677 365.428 309.336 365.446 311 365.446C312.664 365.446 314.323 365.428 315.978 365.393L315.968 364.893C319.282 364.821 322.579 364.679 325.857 364.467L325.89 364.966C329.203 364.752 332.498 364.467 335.772 364.112L335.718 363.615C339.011 363.259 342.283 362.832 345.532 362.336L345.607 362.83C348.891 362.328 352.152 361.757 355.388 361.117L355.291 360.626C358.541 359.983 361.766 359.271 364.964 358.491L365.082 358.977C368.306 358.191 371.503 357.336 374.671 356.414L374.531 355.933C377.709 355.009 380.858 354.016 383.976 352.958L384.137 353.432C387.277 352.366 390.385 351.234 393.462 350.036L393.28 349.57C396.362 348.371 399.412 347.106 402.427 345.778L402.628 346.235C405.66 344.899 408.658 343.499 411.619 342.036L411.397 341.587C414.361 340.123 417.288 338.596 420.176 337.008L420.417 337.446C423.32 335.851 426.183 334.193 429.007 332.477L428.747 332.049C431.571 330.332 434.354 328.555 437.095 326.72L437.373 327.136C440.124 325.294 442.833 323.393 445.498 321.436L445.202 321.033C447.864 319.078 450.482 317.066 453.054 314.999L453.368 315.389C455.947 313.316 458.481 311.187 460.967 309.006L460.637 308.63C463.118 306.452 465.552 304.221 467.936 301.938L468.282 302.299C470.671 300.011 473.011 297.671 475.299 295.282L474.938 294.936C477.221 292.552 479.452 290.118 481.63 287.637L482.006 287.967C484.187 285.481 486.316 282.947 488.389 280.368L487.999 280.054C490.066 277.482 492.078 274.864 494.033 272.202L494.436 272.498C496.393 269.833 498.294 267.124 500.136 264.373L499.72 264.095C501.555 261.354 503.332 258.571 505.049 255.747L505.477 256.007C507.193 253.183 508.851 250.32 510.446 247.417L510.008 247.176C511.596 244.288 513.123 241.361 514.587 238.397L515.036 238.619C516.499 235.658 517.899 232.66 519.235 229.628L518.778 229.427C520.106 226.412 521.371 223.362 522.57 220.28L523.036 220.462C524.234 217.385 525.366 214.276 526.432 211.137L525.958 210.976C527.016 207.858 528.009 204.709 528.933 201.531L529.414 201.671C530.336 198.503 531.191 195.306 531.977 192.082L531.491 191.964C532.271 188.766 532.983 185.541 533.626 182.291L534.117 182.388C534.757 179.152 535.328 175.891 535.83 172.607L535.336 172.532C535.832 169.283 536.259 166.011 536.615 162.718L537.112 162.772C537.467 159.498 537.752 156.203 537.966 152.889L537.467 152.857C537.679 149.579 537.821 146.282 537.893 142.968L538.393 142.978C538.428 141.323 538.446 139.664 538.446 138C538.446 136.336 538.428 134.677 538.393 133.022L537.893 133.032C537.821 129.718 537.679 126.421 537.467 123.143L537.966 123.11C537.752 119.797 537.467 116.502 537.112 113.228L536.615 113.282C536.259 109.989 535.832 106.717 535.336 103.468L535.83 103.393C535.328 100.109 534.757 96.8478 534.117 93.6116L533.626 93.7086C532.983 90.459 532.271 87.2343 531.491 84.0362L531.977 83.9177C531.191 80.694 530.336 77.4971 529.414 74.3289L528.933 74.4686C528.009 71.291 527.016 68.1422 525.958 65.0238L526.431 64.8631C525.366 61.7234 524.234 58.6146 523.036 55.5382L522.57 55.7196C521.371 52.6376 520.106 49.5883 518.778 46.5734L519.235 46.3718C517.899 43.3396 516.499 40.3421 515.036 37.381L514.587 37.6025C513.123 34.639 511.596 31.7122 510.008 28.8236L510.446 28.5827C508.851 25.6804 507.193 22.8166 505.477 19.9932L505.049 20.253C503.332 17.4294 501.555 14.6462 499.72 11.9052L500.136 11.6271C498.294 8.87561 496.393 6.1666 494.436 3.5018L494.033 3.79778C492.078 1.13556 490.066 -1.48242 487.999 -4.05441L488.389 -4.36761C486.316 -6.94746 484.187 -9.48112 482.006 -11.9668L481.63 -11.637C479.452 -14.1185 477.221 -16.5521 474.938 -18.9361L475.299 -19.2819C473.011 -21.6714 470.671 -24.0111 468.282 -26.2992L467.936 -25.9381C465.552 -28.2208 463.118 -30.4521 460.637 -32.63L460.967 -33.0058C458.481 -35.1874 455.947 -37.3157 453.368 -39.3889L453.054 -38.9991C450.482 -41.066 447.864 -43.0779 445.202 -45.0332L445.498 -45.4362C442.833 -47.3933 440.124 -49.2938 437.373 -51.1359L437.095 -50.7204C434.354 -52.5555 431.571 -54.3324 428.747 -56.0494L429.007 -56.4766C426.183 -58.1935 423.32 -59.8506 420.417 -61.4462L420.176 -61.0081C417.288 -62.5961 414.361 -64.1231 411.397 -65.5873L411.619 -66.0356C408.658 -67.4986 405.66 -68.899 402.628 -70.2352L402.426 -69.7777C399.412 -71.1062 396.362 -72.3711 393.28 -73.5705L393.462 -74.0365C390.385 -75.2337 387.276 -76.366 384.137 -77.4315L383.976 -76.9581C380.858 -78.0164 377.709 -79.0088 374.531 -79.9335L374.671 -80.4136C371.503 -81.3356 368.306 -82.1906 365.082 -82.9769L364.964 -82.4911C361.766 -83.2711 358.541 -83.9834 355.291 -84.6262L355.388 -85.1167C352.152 -85.757 348.891 -86.3285 345.607 -86.8298L345.532 -86.3356C342.283 -86.8316 339.011 -87.2587 335.718 -87.6154L335.772 -88.1125C332.498 -88.4671 329.203 -88.7522 325.889 -88.9664L325.857 -88.4674C322.579 -88.6792 319.282 -88.8215 315.968 -88.8927L315.978 -89.3925C314.323 -89.4281 312.664 -89.4459 311 -89.4459C309.336 -89.4459 307.677 -89.4281 306.022 -89.3925L306.032 -88.8926C302.718 -88.8215 299.421 -88.6792 296.143 -88.4674L296.11 -88.9663C292.797 -88.7522 289.502 -88.4671 286.228 -88.1125L286.282 -87.6154C282.989 -87.2587 279.717 -86.8316 276.468 -86.3355L276.393 -86.8298C273.109 -86.3285 269.848 -85.7569 266.612 -85.1167L266.709 -84.6262C263.459 -83.9833 260.234 -83.2711 257.036 -82.4911L256.918 -82.9768C253.694 -82.1906 250.497 -81.3356 247.329 -80.4136L247.469 -79.9335C244.291 -79.0087 241.142 -78.0163 238.024 -76.958L237.863 -77.4315C234.723 -76.366 231.615 -75.2337 228.538 -74.0364L228.72 -73.5705C225.638 -72.371 222.588 -71.1062 219.573 -69.7776L219.372 -70.2352C216.34 -68.899 213.342 -67.4986 210.381 -66.0355L210.602 -65.5873C207.639 -64.1231 204.712 -62.5961 201.824 -61.008L201.583 -61.4462C198.68 -59.8506 195.817 -58.1934 192.993 -56.4766L193.253 -56.0493C190.429 -54.3323 187.646 -52.5554 184.905 -50.7204L184.627 -51.1358C181.876 -49.2938 179.167 -47.3933 176.502 -45.4361L176.798 -45.0331C174.136 -43.0779 171.518 -41.0659 168.946 -38.9991L168.632 -39.3888C166.053 -37.3157 163.519 -35.1874 161.033 -33.0058L161.363 -32.63C158.881 -30.452 156.448 -28.2208 154.064 -25.9381L153.718 -26.2992C151.329 -24.0111 148.989 -21.6714 146.701 -19.2818L147.062 -18.936C144.779 -16.5521 142.548 -14.1185 140.37 -11.6369L139.994 -11.9668C137.813 -9.48108 135.684 -6.94742 133.611 -4.36757L134.001 -4.05437C131.934 -1.48238 129.922 1.1356 127.967 3.79782L127.564 3.50185C125.607 6.16664 123.706 8.87566 121.864 11.6271L122.28 11.9053C120.445 14.6463 118.668 17.4295 116.951 20.2531L116.523 19.9933C114.807 22.8167 113.149 25.6804 111.554 28.5828L111.992 28.8236C110.404 31.7122 108.877 34.6391 107.413 37.6026L106.964 37.3811C105.501 40.3422 104.101 43.3397 102.765 46.3719L103.222 46.5735C101.894 49.5884 100.629 52.6377 99.4295 55.7197L98.9635 55.5383C97.7663 58.6147 96.634 61.7236 95.5685 64.8632L96.0419 65.0239C94.9836 68.1423 93.9912 71.2911 93.0665 74.4687L92.5864 74.329C91.6644 77.4973 90.8094 80.6941 90.0231 83.9178L90.5089 84.0363C89.7289 87.2345 89.0166 90.4591 88.3737 93.7088L87.8833 93.6118C87.243 96.8479 86.6715 100.109 86.1702 103.393L86.6644 103.468C86.1684 106.717 85.7413 109.989 85.3846 113.282L84.8875 113.228C84.5329 116.502 84.2478 119.797 84.0336 123.111L84.5326 123.143C84.3208 126.421 84.1785 129.718 84.1073 133.032L83.6075 133.022C83.5719 134.677 83.5541 136.336 83.5541 138C83.5541 139.664 83.5719 141.323 83.6075 142.978L84.1074 142.968C84.1785 146.282 84.3208 149.579 84.5326 152.857L84.0337 152.89C84.2478 156.203 84.5329 159.498 84.8875 162.772L85.3846 162.718C85.7413 166.011 86.1684 169.283 86.6644 172.532L86.1702 172.607C86.6715 175.891 87.2431 179.152 87.8833 182.388L88.3738 182.291C89.0166 185.541 89.7289 188.766 90.5089 191.964L90.0232 192.082C90.8094 195.306 91.6644 198.503 92.5864 201.671L93.0665 201.531C93.9913 204.709 94.9837 207.858 96.042 210.976L95.5685 211.137C96.634 214.277 97.7663 217.385 98.9636 220.462L99.4295 220.28C100.629 223.362 101.894 226.412 103.222 229.427L102.765 229.628C104.101 232.66 105.501 235.658 106.964 238.619L107.413 238.397C108.877 241.361 110.404 244.288 111.992 247.176L111.554 247.417C113.149 250.32 114.807 253.183 116.523 256.007L116.951 255.747C118.668 258.571 120.445 261.354 122.28 264.095L121.864 264.373C123.706 267.124 125.607 269.833 127.564 272.498L127.967 272.202C129.922 274.864 131.934 277.482 134.001 280.054L133.611 280.368C135.684 282.947 137.813 285.481 139.994 287.967L140.37 287.637C142.548 290.119 144.779 292.552 147.062 294.936L146.701 295.282C148.989 297.671 151.329 300.011 153.718 302.299L154.064 301.938C156.448 304.221 158.882 306.452 161.363 308.63L161.033 309.006C163.519 311.187 166.053 313.316 168.632 315.389L168.946 314.999C171.518 317.066 174.136 319.078 176.798 321.033L176.502 321.436C179.167 323.393 181.876 325.294 184.627 327.136L184.905 326.72C187.646 328.555 190.429 330.332 193.253 332.049L192.993 332.477C195.817 334.193 198.68 335.851 201.583 337.446L201.824 337.008C204.712 338.596 207.639 340.123 210.603 341.587L210.381 342.036C213.342 343.499 216.34 344.899 219.372 346.235L219.573 345.778C222.588 347.106 225.638 348.371 228.72 349.57L228.538 350.036C231.615 351.234 234.724 352.366 237.863 353.432L238.024 352.958C241.142 354.016 244.291 355.009 247.469 355.933L247.329 356.414C250.497 357.336 253.694 358.191 256.918 358.977L257.036 358.491C260.234 359.271 263.459 359.983 266.709 360.626L266.612 361.117C269.848 361.757 273.109 362.328 276.393 362.83L276.468 362.336C279.717 362.832 282.989 363.259 286.282 363.615L286.228 364.112C289.502 364.467 292.797 364.752 296.111 364.966L296.143 364.467ZM311 448.5C309.296 448.5 307.596 448.486 305.899 448.459L305.891 448.959C302.492 448.904 299.106 448.795 295.734 448.632L295.758 448.132C292.358 447.968 288.972 447.749 285.601 447.476L285.561 447.975C282.171 447.7 278.796 447.371 275.437 446.989L275.493 446.492C272.12 446.108 268.762 445.67 265.423 445.179L265.35 445.673C261.981 445.178 258.63 444.628 255.297 444.026L255.386 443.534C252.046 442.93 248.725 442.272 245.424 441.562L245.319 442.051C241.994 441.337 238.69 440.569 235.406 439.749L235.527 439.264C232.232 438.441 228.958 437.565 225.705 436.638L225.568 437.119C222.3 436.187 219.055 435.204 215.832 434.169L215.985 433.693C212.754 432.656 209.547 431.567 206.363 430.428L206.195 430.899C202.994 429.753 199.817 428.557 196.666 427.31L196.85 426.845C193.697 425.598 190.568 424.301 187.467 422.954L187.268 423.413C184.152 422.06 181.062 420.658 178 419.207L178.214 418.755C175.149 417.303 172.111 415.802 169.101 414.253L168.872 414.697C165.853 413.143 162.863 411.542 159.902 409.893L160.146 409.456C157.184 407.806 154.252 406.11 151.351 404.367L151.094 404.796C148.182 403.047 145.302 401.252 142.453 399.412L142.725 398.992C139.878 397.153 137.063 395.268 134.282 393.34L133.997 393.75C131.208 391.816 128.451 389.838 125.73 387.816L126.028 387.414C123.307 385.393 120.62 383.329 117.969 381.222L117.658 381.613C115.001 379.502 112.379 377.348 109.794 375.152L110.118 374.771C107.536 372.578 104.99 370.343 102.481 368.068L102.145 368.439C99.6313 366.159 97.1551 363.839 94.7174 361.479L95.0652 361.12C92.6313 358.764 90.2359 356.369 87.8799 353.935L87.5207 354.283C85.161 351.845 82.8408 349.369 80.5612 346.855L80.9316 346.519C78.6565 344.01 76.422 341.464 74.2289 338.882L73.8478 339.206C71.6522 336.621 69.4982 333.999 67.3868 331.342L67.7782 331.031C65.6712 328.38 63.6066 325.693 61.5855 322.972L61.1841 323.271C59.1622 320.549 57.1836 317.792 55.2495 315.003L55.6604 314.718C53.7316 311.937 51.8471 309.122 50.0078 306.275L49.5879 306.547C47.7476 303.698 45.9526 300.818 44.2039 297.906L44.6325 297.649C42.89 294.748 41.1936 291.816 39.5442 288.854L39.1073 289.098C37.4585 286.137 35.8566 283.147 34.3027 280.128L34.7473 279.899C33.1984 276.889 31.6972 273.851 30.2447 270.786L29.7929 271C28.3421 267.938 26.9399 264.848 25.5872 261.732L26.0458 261.533C24.6993 258.431 23.4019 255.303 22.1547 252.15L21.6897 252.334C20.4433 249.183 19.2469 246.006 18.1014 242.805L18.5722 242.637C17.4329 239.453 16.3442 236.246 15.3069 233.015L14.8308 233.168C13.7961 229.945 12.8125 226.7 11.881 223.432L12.3619 223.295C11.4347 220.042 10.5591 216.768 9.73628 213.473L9.25118 213.594C8.43117 210.31 7.66337 207.006 6.9487 203.681L7.43752 203.576C6.72771 200.275 6.07039 196.954 5.46649 193.614L4.97447 193.703C4.37181 190.37 3.82226 187.019 3.32672 183.65L3.82139 183.577C3.33011 180.238 2.892 176.88 2.50796 173.507L2.01116 173.563C1.62879 170.204 1.29993 166.829 1.02545 163.439L1.52382 163.399C1.25095 160.028 1.03192 156.642 0.867565 153.242L0.368149 153.266C0.205154 149.894 0.0958637 146.508 0.0411141 143.109L0.541049 143.101C0.513718 141.404 0.5 139.704 0.5 138C0.5 136.296 0.513718 134.596 0.54105 132.899L0.0411146 132.891C0.0958643 129.492 0.205155 126.106 0.368149 122.734L0.867566 122.758C1.03192 119.358 1.25095 115.972 1.52382 112.601L1.02545 112.561C1.29993 109.171 1.62879 105.796 2.01116 102.437L2.50796 102.493C2.892 99.1196 3.33011 95.7624 3.82139 92.4225L3.32672 92.3497C3.82226 88.9809 4.37181 85.6297 4.97447 82.2969L5.46649 82.3859C6.0704 79.0462 6.72771 75.7252 7.43753 72.4236L6.9487 72.3185C7.66337 68.9944 8.43117 65.6899 9.25117 62.4062L9.73628 62.5273C10.5591 59.2321 11.4347 55.9577 12.3619 52.7051L11.881 52.568C12.8125 49.3004 13.7961 46.0548 14.8308 42.8321L15.3069 42.985C16.3442 39.7543 17.4329 36.5467 18.5722 33.3632L18.1015 33.1947C19.2469 29.9939 20.4433 26.8173 21.6897 23.666L22.1547 23.8499C23.4019 20.6965 24.6993 17.5685 26.0458 14.4667L25.5872 14.2676C26.9399 11.1516 28.3421 8.06213 29.7929 5.00012L30.2447 5.2142C31.6972 2.14864 33.1984 -0.889343 34.7473 -3.89874L34.3027 -4.12756C35.8566 -7.14668 37.4585 -10.1371 39.1073 -13.0977L39.5442 -12.8544C41.1935 -15.8161 42.89 -18.7479 44.6325 -21.649L44.2039 -21.9064C45.9526 -24.8178 47.7476 -27.6982 49.5879 -30.5465L50.0078 -30.2752C51.8471 -33.1219 53.7316 -35.9366 55.6604 -38.7183L55.2495 -39.0032C57.1836 -41.7925 59.1621 -44.5486 61.1841 -47.2705L61.5855 -46.9723C63.6066 -49.6931 65.6712 -52.3797 67.7782 -55.031L67.3868 -55.3421C69.4982 -57.999 71.6522 -60.6206 73.8478 -63.2058L74.2289 -62.8821C76.422 -65.4645 78.6565 -68.0105 80.9316 -70.5191L80.5612 -70.855C82.8408 -73.3686 85.161 -75.8449 87.5207 -78.2826L87.8799 -77.9348C90.2359 -80.3687 92.6313 -82.7641 95.0652 -85.1201L94.7174 -85.4793C97.1551 -87.839 99.6314 -90.1592 102.145 -92.4388L102.481 -92.0684C104.99 -94.3435 107.536 -96.578 110.118 -98.7711L109.794 -99.1522C112.379 -101.348 115.001 -103.502 117.658 -105.613L117.969 -105.222C120.62 -107.329 123.307 -109.393 126.028 -111.414L125.729 -111.816C128.451 -113.838 131.208 -115.816 133.997 -117.75L134.282 -117.34C137.063 -119.268 139.878 -121.153 142.725 -122.992L142.453 -123.412C145.302 -125.252 148.182 -127.047 151.094 -128.796L151.351 -128.368C154.252 -130.11 157.184 -131.806 160.146 -133.456L159.902 -133.893C162.863 -135.541 165.853 -137.143 168.872 -138.697L169.101 -138.253C172.111 -139.802 175.149 -141.303 178.214 -142.755L178 -143.207C181.062 -144.658 184.152 -146.06 187.268 -147.413L187.467 -146.954C190.568 -148.301 193.697 -149.598 196.85 -150.845L196.666 -151.31C199.817 -152.557 202.994 -153.753 206.195 -154.899L206.363 -154.428C209.547 -155.567 212.754 -156.656 215.985 -157.693L215.832 -158.169C219.055 -159.204 222.3 -160.187 225.568 -161.119L225.705 -160.638C228.958 -161.565 232.232 -162.441 235.527 -163.264L235.406 -163.749C238.69 -164.569 241.994 -165.337 245.319 -166.051L245.424 -165.562C248.725 -166.272 252.046 -166.93 255.386 -167.534L255.297 -168.026C258.63 -168.628 261.981 -169.178 265.35 -169.673L265.423 -169.179C268.762 -169.67 272.12 -170.108 275.493 -170.492L275.437 -170.989C278.796 -171.371 282.171 -171.7 285.561 -171.975L285.601 -171.476C288.972 -171.749 292.358 -171.968 295.758 -172.132L295.734 -172.632C299.106 -172.795 302.492 -172.904 305.891 -172.959L305.899 -172.459C307.596 -172.486 309.296 -172.5 311 -172.5C312.704 -172.5 314.404 -172.486 316.101 -172.459L316.109 -172.959C319.508 -172.904 322.894 -172.795 326.266 -172.632L326.242 -172.132C329.642 -171.968 333.028 -171.749 336.399 -171.476L336.439 -171.975C339.829 -171.7 343.204 -171.371 346.563 -170.989L346.507 -170.492C349.88 -170.108 353.238 -169.67 356.577 -169.179L356.65 -169.673C360.019 -169.178 363.37 -168.628 366.703 -168.026L366.614 -167.534C369.954 -166.93 373.275 -166.272 376.576 -165.562L376.681 -166.051C380.006 -165.337 383.31 -164.569 386.594 -163.749L386.473 -163.264C389.768 -162.441 393.042 -161.565 396.295 -160.638L396.432 -161.119C399.7 -160.187 402.945 -159.204 406.168 -158.169L406.015 -157.693C409.246 -156.656 412.453 -155.567 415.637 -154.428L415.805 -154.899C419.006 -153.753 422.183 -152.557 425.334 -151.31L425.15 -150.845C428.303 -149.598 431.432 -148.301 434.533 -146.954L434.732 -147.413C437.848 -146.06 440.938 -144.658 444 -143.207L443.786 -142.755C446.851 -141.303 449.889 -139.802 452.899 -138.253L453.128 -138.697C456.147 -137.143 459.137 -135.541 462.098 -133.893L461.854 -133.456C464.816 -131.806 467.748 -130.11 470.649 -128.368L470.906 -128.796C473.818 -127.047 476.698 -125.252 479.547 -123.412L479.275 -122.992C482.122 -121.153 484.937 -119.268 487.718 -117.34L488.003 -117.75C490.792 -115.816 493.549 -113.838 496.27 -111.816L495.972 -111.415C498.693 -109.393 501.38 -107.329 504.031 -105.222L504.342 -105.613C506.999 -103.502 509.621 -101.348 512.206 -99.1522L511.882 -98.7711C514.464 -96.578 517.01 -94.3435 519.519 -92.0684L519.855 -92.4388C522.369 -90.1592 524.845 -87.839 527.283 -85.4793L526.935 -85.1201C529.369 -82.7641 531.764 -80.3687 534.12 -77.9348L534.479 -78.2826C536.839 -75.8449 539.159 -73.3686 541.439 -70.855L541.068 -70.5191C543.343 -68.0104 545.578 -65.4644 547.771 -62.8821L548.152 -63.2058C550.348 -60.6206 552.502 -57.999 554.613 -55.3421L554.222 -55.031C556.329 -52.3797 558.393 -49.6931 560.414 -46.9723L560.816 -47.2705C562.838 -44.5486 564.816 -41.7924 566.75 -39.0032L566.34 -38.7183C568.268 -35.9366 570.153 -33.1219 571.992 -30.2752L572.412 -30.5465C574.252 -27.6981 576.047 -24.8177 577.796 -21.9064L577.367 -21.6489C579.11 -18.7479 580.806 -15.8161 582.456 -12.8544L582.893 -13.0977C584.542 -10.1371 586.143 -7.14667 587.697 -4.12755L587.253 -3.89873C588.802 -0.889328 590.303 2.14865 591.755 5.21423L592.207 5.00015C593.658 8.06216 595.06 11.1517 596.413 14.2677L595.954 14.4668C597.301 17.5685 598.598 20.6966 599.845 23.8499L600.31 23.666C601.557 26.8174 602.753 29.9939 603.899 33.1947L603.428 33.3632C604.567 36.5468 605.656 39.7544 606.693 42.985L607.169 42.8322C608.204 46.0549 609.187 49.3005 610.119 52.5681L609.638 52.7051C610.565 55.9577 611.441 59.2321 612.264 62.5273L612.749 62.4062C613.569 65.69 614.337 68.9944 615.051 72.3186L614.562 72.4237C615.272 75.7252 615.93 79.0463 616.534 82.386L617.026 82.297C617.628 85.6297 618.178 88.981 618.673 92.3498L618.179 92.4225C618.67 95.7624 619.108 99.1196 619.492 102.493L619.989 102.437C620.371 105.796 620.7 109.171 620.975 112.561L620.476 112.601C620.749 115.972 620.968 119.358 621.132 122.758L621.632 122.734C621.795 126.106 621.904 129.492 621.959 132.891L621.459 132.899C621.486 134.596 621.5 136.297 621.5 138C621.5 139.704 621.486 141.404 621.459 143.101L621.959 143.109C621.904 146.508 621.795 149.894 621.632 153.266L621.132 153.242C620.968 156.642 620.749 160.028 620.476 163.399L620.975 163.439C620.7 166.829 620.371 170.204 619.989 173.563L619.492 173.507C619.108 176.88 618.67 180.238 618.179 183.577L618.673 183.65C618.178 187.019 617.628 190.37 617.026 193.703L616.534 193.614C615.93 196.954 615.272 200.275 614.562 203.576L615.051 203.681C614.337 207.006 613.569 210.31 612.749 213.594L612.264 213.473C611.441 216.768 610.565 220.042 609.638 223.295L610.119 223.432C609.187 226.7 608.204 229.945 607.169 233.168L606.693 233.015C605.656 236.246 604.567 239.453 603.428 242.637L603.899 242.805C602.753 246.006 601.557 249.183 600.31 252.334L599.845 252.15C598.598 255.303 597.301 258.432 595.954 261.533L596.413 261.732C595.06 264.848 593.658 267.938 592.207 271L591.755 270.786C590.303 273.851 588.802 276.889 587.253 279.899L587.697 280.128C586.143 283.147 584.542 286.137 582.893 289.098L582.456 288.854C580.806 291.816 579.11 294.748 577.367 297.649L577.796 297.906C576.047 300.818 574.252 303.698 572.412 306.547L571.992 306.275C570.153 309.122 568.268 311.937 566.34 314.718L566.75 315.003C564.816 317.792 562.838 320.549 560.816 323.271L560.414 322.972C558.393 325.693 556.329 328.38 554.222 331.031L554.613 331.342C552.502 333.999 550.348 336.621 548.152 339.206L547.771 338.882C545.578 341.464 543.343 344.01 541.068 346.519L541.439 346.855C539.159 349.369 536.839 351.845 534.479 354.283L534.12 353.935C531.764 356.369 529.369 358.764 526.935 361.12L527.283 361.479C524.845 363.839 522.369 366.159 519.855 368.439L519.519 368.068C517.01 370.343 514.464 372.578 511.882 374.771L512.206 375.152C509.621 377.348 506.999 379.502 504.342 381.613L504.031 381.222C501.38 383.329 498.693 385.393 495.972 387.414L496.271 387.816C493.549 389.838 490.792 391.816 488.003 393.75L487.718 393.34C484.937 395.268 482.122 397.153 479.275 398.992L479.546 399.412C476.698 401.252 473.818 403.047 470.906 404.796L470.649 404.367C467.748 406.11 464.816 407.806 461.854 409.456L462.098 409.893C459.137 411.542 456.147 413.143 453.128 414.697L452.899 414.253C449.889 415.802 446.851 417.303 443.786 418.755L444 419.207C440.938 420.658 437.848 422.06 434.732 423.413L434.533 422.954C431.431 424.301 428.303 425.598 425.15 426.845L425.334 427.31C422.183 428.557 419.006 429.753 415.805 430.899L415.637 430.428C412.453 431.567 409.246 432.656 406.015 433.693L406.168 434.169C402.945 435.204 399.7 436.188 396.432 437.119L396.295 436.638C393.042 437.565 389.768 438.441 386.473 439.264L386.594 439.749C383.31 440.569 380.006 441.337 376.681 442.051L376.576 441.562C373.275 442.272 369.954 442.93 366.614 443.534L366.703 444.026C363.37 444.628 360.019 445.178 356.65 445.673L356.577 445.179C353.238 445.67 349.88 446.108 346.507 446.492L346.563 446.989C343.204 447.371 339.829 447.7 336.439 447.975L336.399 447.476C333.028 447.749 329.642 447.968 326.242 448.132L326.266 448.632C322.894 448.795 319.508 448.904 316.109 448.959L316.101 448.459C314.404 448.486 312.703 448.5 311 448.5Z"
            stroke="white"
            stroke-dasharray="10 10"
          />
        </svg>
      </div> -->
      <div class="container">
        <div class="row row-wrap">
          <div class="col-12 text-center">
            <h1>Terms of Use</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="page-main-content">
        <div class="row">
          <div class="col-12 col-lg-10 m-auto">
            <p>
              By accessing <a href="#">www.thekredible.com</a> website, you agree
              with Dinkum Data Solutions Private Limited, that you will comply
              with these terms of use (this “Agreement”). Our Website and App
              together shall be referred to as “Platform” and all services,
              functionalities or operations through these Platforms shall be
              referred to as “Services”. We’ve updated our Terms of Service to
              clarify our rights and obligations as they relate to Our new
              features and functionality. This includes more detail about how we
              process the personal data contained in the third-party accounts you
              choose to integrate with Us.
            </p>
            <p>
              All references to the Platform and Services shall be made using
              “Our” or “Us” or “We” and all references to the User and/or
              subscriber shall be made using “You”.
            </p>
            <p>
              Please read on to learn the rules and restrictions that govern your
              use of Our Platform (the “Service”). If you have any questions,
              comments, or concerns regarding these terms or the Service, please
              contact us at support&#64;thekredible.com
            </p>
            <p>
              These Terms govern your access to the Service and use of all data,
              content and other information on Our Platform and other properties
              and include the provisions in this document
            </p>
            <p>For the purposes of this Agreement;</p>
            <p>
              “User” shall mean any person using the platform, who has entered
              into an agreement with us to do so, whether directly or through
              another entity’s identity, being so authorized to do so.
            </p>
            <p>
              “Subscriber” means either any user that has paid for its
              subscription and usage of the platform. If you are an Authorized
              User and the Subscription Agreement or Order Form under which you
              are an Authorized User provides for additional or different rights
              for your use, those terms providing for additional rights will
              prevail over the terms of this Agreement.
            </p>

            <p>
              An “Authorized User” is an employee of Subscriber who is a natural
              person, who works within the organization listed on the order form,
              and who is designated by Subscriber as a user under this Agreement.
            </p>
            <p>
              The new Terms of Service went into effect on 20 Mar, 2022 and are
              listed immediately below. PLEASE NOTE THAT YOUR USE OF AND ACCESS TO
              OUR SERVICE (DEFINED BELOW) IS SUBJECT TO THE FOLLOWING TERMS; IF
              YOU DO NOT AGREE TO ALL OF THE FOLLOWING, YOU MAY NOT USE OR ACCESS
              THE SERVICE IN ANY MANNER.
            </p>
            <p>
              Effective Date: This Agreement is effective upon your use of the
              Site or Applications.
            </p>

            <p>
              We are constantly trying to improve our Service, so these Terms may
              need to change along with the Service. We reserve the right to
              change these Terms at any time, but if we do, we will bring it to
              your attention by placing a notice on the Platform, by sending you
              an email, and/or by some other means.
            </p>
            <p>
              If you don’t agree with the new Terms, you are free to reject them;
              unfortunately, that means you will no longer be able to use the
              Service. If you use the Service in any way after a change to these
              Terms is effective, that means you agree to all of the changes.
            </p>
            <p>
              Except for changes by us as described here, no other amendment or
              modification of these Terms will be effective unless in writing and
              signed by you and Us.
            </p>
            <ol class="main-list">
              <li>
                <p>Using our Platform:</p>
                <ol class="list">
                  <li>
                    <span>1.1.</span>As part of using the Service you may be
                    required to sign up for an account and select a password and
                    email or user name (your “User ID”). You promise to provide us
                    with accurate, complete, and updated registration information
                    about yourself. You may not select as your User ID a name that
                    you don’t have the right to use, or another person’s name with
                    the intent to impersonate that person.
                  </li>
                  <li>
                    <span>1.2.</span>Your right to access the Service is personal
                    to you and you may not transfer your account to anyone else
                    without our prior written permission. You will not share your
                    account or password with anyone, and you must protect the
                    security of your account and your password.
                  </li>
                  <li>
                    <span>1.3.</span>You’re responsible for any activity
                    associated with your account. You will only use the Service
                    and Content (defined below) in a manner that complies with all
                    laws that apply to you. If your use of the Service is
                    prohibited by applicable laws, then you aren’t authorized to
                    use the Service. We can’t and won’t be responsible for your
                    use of the Service in any way that breaks the law.
                  </li>
                  <li>
                    <span>1.4.</span>You represent and warrant that you are of
                    legal age to form a binding contract (or if not, you’ve
                    received your parent’s or guardian’s permission to use the
                    Service and gotten your parent or guardian to agree to these
                    Terms on your behalf).
                  </li>
                  <li>
                    <span>1.5.</span>If you’re agreeing to these Terms on behalf
                    of an organization or entity, you represent and warrant that
                    you are authorized to agree to these Terms on that
                    organization or entity’s behalf and bind them to these Terms
                    (in which case, the references to “you” and “your” in these
                    Terms, except for in this sentence, refer to that organization
                    or entity).
                  </li>
                </ol>
              </li>
              <li>
                <p>Services</p>
                <ol class="list">
                  <li>
                    <span>2.1.</span>
                    <p>
                      Site & Applications: We provide data (the “Services”) via
                      our website located at
                      <a href="#">www.thekredible.com</a> (the “Site”).
                      Additionally, an Authorized User under a subscription
                      agreement may be given access to one or more of Our
                      Platforms for the purpose of accessing the content of the
                      Site (the “Content”) through that Application.
                    </p>
                  </li>
                  <li>
                    <span>2.2.</span>For the purposes of this Agreement, “Content”
                    also includes any written reports sold or otherwise delivered
                    to Subscriber as well as any information Subscriber receives
                    from Our analysts, regardless of how that information is
                    communicated to Subscriber. We may suspend, disable or
                    terminate your access to the Services, Site, Application, or
                    Content.
                  </li>
                </ol>
              </li>
              <li>
                <p>Your account:</p>
                <ol class="list">
                  <li>
                    <span>3.1.</span>To use the Platform you have to register with
                    Us.
                  </li>
                  <li>
                    <span>3.2.</span>Your account is only for use by you and you
                    are responsible for your conduct. You will always use a strong
                    password to protect your account and keep it confidential. You
                    will not share your account access on the Platform with others
                    or let anybody impersonate you using your access credentials.
                    You take responsibility that your account will not be used in
                    any way which contradicts any applicable law or the Terms
                    mentioned herein. We have a right but not an obligation to
                    review your conduct to ensure compliance with these Terms. If
                    there is a misuse of your account; you will immediately report
                    to Us.
                  </li>
                  <li>
                    <span>3.3.</span>We may take necessary steps including but not
                    limited to terminating your access to the Platform if we
                    believe that you are in breach of the Terms mentioned herein
                    or your failure to comply with any applicable law.
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Trial Access:
                  <span
                    >If We agree to provide trial access, such access may be
                    limited to certain subsections of Content.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Updates:
                  <span
                    >We may modify the Services, Site, Applications, or Content at
                    any time.</span
                  >
                </p>
              </li>
              <li>
                <p>Users:</p>
                <ol class="list">
                  <li>
                    <span>6.1.</span>Requirements for Use: The Site, Applications,
                    and Content may only be accessed through valid login
                    credentials issued to you by US. You must register for a
                    single user account using a unique username and password and
                    complete the registration process by entering your general
                    contact information in the “My Account” section of the Our
                    Site or Application including current, complete and accurate
                    information as prompted by the form.
                  </li>
                  <li>
                    <span>6.2.</span>Responsibility for Use: Your account username
                    and password are solely for your individual use to access the
                    site and you may not permit anyone else to use them or your
                    account. You are responsible for all use of the Applications,
                    Site, Services, and Content accessed through your account
                    (including any illicit use of your user ID or password) and
                    for preventing such unauthorized use.
                  </li>
                  <li>
                    <span>6.3.</span>Reporting Unauthorized Use or Access: If you
                    believe there has been unauthorized access or use of the
                    Applications, the Site or any Content through your account
                    credentials, you must notify Us immediately by emailing at
                    support&#64;thekredible.com
                  </li>
                  <li>
                    <span>6.4.</span>Requirements for Use: All Authorized Users
                    must: (A) complete the Site registration process using a
                    unique Site username and password or SSO; (B) only access the
                    Services using SSO or an email address at the Subscriber’s
                    Internet domain; (C) agree to the Site terms of use (the
                    “Terms of Use”); and (D) only use the Site, Applications,
                    Content, and Services on behalf of Subscriber. If a term in
                    the Terms of Use conflicts with a term of this Agreement, the
                    term contained in this Agreement will control.
                  </li>
                </ol>
              </li>
              <li>
                <p>Payment Terms</p>
                <ol class="list">
                  <li>
                    <span>7.1.</span>Fees: The Subscriber will pay all fees listed
                    in the relevant Order (“Fees”). The Fees only apply with
                    respect to the term provided in the Order. We may change the
                    Fees for any Renewal Term (as defined below) upon notice to
                    Subscriber no later than 45 days prior to the then-current
                    anniversary of the Effective Date. Unless provided otherwise,
                    all amounts paid under this Agreement are non-refundable.
                  </li>
                  <li>
                    <span>7.2.</span>Timing of Payment: The Subscriber will pay
                    all Fees contained on an Order within 15 days following the
                    Effective Date. If the Agreement is automatically renewed,
                    Subscriber will pay all Fees for renewal terms on each
                    anniversary of the Effective Date during the Term. If such
                    payment is not timely made, We may suspend Subscriber’s access
                    to the Site, Applications, and Services. Unpaid Fee balances
                    will accrue interest at the rate of 1.5% per month.
                  </li>
                  <li>
                    <span>7.3.</span>Taxes: The Subscriber is solely responsible
                    for all applicable sales, use, and other taxes or similar
                    charges or duties incurred in connection with this Agreement
                    (collectively, “Taxes”). Subscriber will promptly reimburse Us
                    if We are required to pay any Taxes for which Subscriber is
                    legally responsible..
                  </li>
                </ol>
              </li>
              <li>
                <p>User’s Rights on the Platform:</p>
                <ol class="list">
                  <li>
                    <span>8.1.</span>The materials displayed or published or
                    available on or through the Service, including, but not
                    limited to, text, graphics, data, articles, information,
                    photos, images, illustrations, User Submissions, and so forth
                    (all of the foregoing, the “Content”) are protected by
                    copyright and/or other intellectual property laws.
                  </li>
                  <li>
                    <span>8.2.</span>You promise to abide by all copyright
                    notices, trademark rules, information, and restrictions
                    contained in any Content you access through the Service in any
                    way (including through the Website, API, Mobile applications,
                    downloads, etc.).
                  </li>
                  <li>
                    <span>8.3.</span>You will not use, copy, reproduce, adapt,
                    modify, translate, publish, broadcast, transmit, distribute,
                    perform, upload, display, license, sell or otherwise exploit
                    for any purpose any Content not owned by you in a way that
                    violates someone else’s (including Our) rights.
                  </li>
                  <li class="listinside">
                    <p class="d-flex">
                      <span>8.4.</span>Notwithstanding the foregoing, you may
                      display insubstantial excerpts of Content for criticism,
                      commentary, news reporting, teaching, scholarship, research
                      and similar purposes, provided:
                    </p>
                    <ol class="inside-list">
                      <li>
                        <span>8.4.1</span>The use does not compete with the
                        Service; and
                      </li>
                      <li>
                        <span>8.4.2</span>Proper attribution is provided to;
                      </li>
                      <li>
                        <span>8.4.3</span>Any other uses of Content require Our
                        prior written consent.
                      </li>
                    </ol>
                  </li>
                  <li><span>8.5.</span>You understand that We own the Service</li>
                  <li>
                    <span>8.6.</span>You won’t modify, publish, transmit,
                    participate in the transfer or sale of, reproduce (except as
                    expressly provided in this Section), create derivative works
                    based on, re-sell, sublicense, re-distribute, or otherwise
                    exploit any aspect of the Service.
                  </li>
                  <li>
                    <span>8.7.</span>If you would like to use Content in any
                    manner other than as expressly permitted by these Terms,
                    please visit our products page to learn more about the
                    different ways that We provide its data and find the solution
                    that is right for you. You may be required to submit an
                    application and/or meet certain eligibility criteria in order
                    to participate in a program, and there may be different terms
                    and conditions which apply to the specific program that you
                    choose. You must agree to all terms and conditions and, if
                    applicable, pay all required fees which apply to your specific
                    program. These Terms apply to all such programs unless
                    specifically stated otherwise in the applicable program terms.
                  </li>
                </ol>
              </li>
              <li>
                <p>License to Use:</p>
                <ol class="list">
                  <li>
                    <span>9.1.</span>Certain parts of the Service may allow you to
                    integrate with other third-party accounts of yours, such as
                    data from your productivity tools (e.g. CRMs, e-mail, sales
                    engagement tools, etc.).
                  </li>
                  <li>
                    <span>9.2.</span>If you choose to use these parts of the
                    Service, you grant Us all licenses and rights necessary for Us
                    to provide the Service to you, including a license for Us to
                    read and write to your third-party account, to extract data
                    from and upload data to your third-party account, and to share
                    data extracted from your third-party account with other
                    members of your team or institution, as further described in
                    the next paragraph.
                  </li>
                  <li>
                    <span>9.3.</span>Anything you post, upload, share, store,
                    integrate with or otherwise provide through the Service is
                    your “User Submission.” Some User Submissions (such as profile
                    data you contribute to Us, or information you elect to share
                    with other users through the Service, such as your team
                    members) are viewable by other users.
                  </li>
                  <li>
                    <span>9.4.</span>For all User Submissions, you hereby grant Us
                    a royalty-free, perpetual, sublicensable, irrevocable, and
                    worldwide license to translate, modify, aggregate, reproduce,
                    display, distribute, and otherwise use and exploit such User
                    Submissions for Our business purposes, including to provide,
                    develop, and improve our products and services, except, for
                    the avoidance of doubt, the foregoing shall not permit Us to
                    publish, display or distribute your data from your
                    productivity tools (e.g. CRMs, e-mail, sales engagement tools,
                    etc.) in a manner that is identifiable as originating from you
                    without your written consent.
                  </li>
                  <li>
                    <span>9.5.</span>Please note that the foregoing license is
                    subject to our Privacy Policy to the extent it relates to User
                    Submissions that are also your personally-identifiable
                    information, and to our Data Use Addendum to the extent it
                    relates to User Submissions that are the
                    personally-identifiable information of another person. You are
                    prohibited from including Social Security Numbers, driver’s
                    license numbers, passport numbers, financial account and
                    payment card information precise geolocation, and health and
                    biometric information as part of any User Submission.
                  </li>
                </ol>
              </li>
              <li>
                <p>Link to other sites:</p>
                <ol class="list">
                  <li>
                    <span>10.1.</span>The Platform may contain links to other
                    sites and may be governed by respective terms of use not
                    covered herein. Accessing or using these sites shall be at
                    your discretion and We shall bear no liability whatsoever.
                  </li>
                  <li>
                    <span>10.2.</span>Any use or attempt to use any web crawlers,
                    robot, spider, computer code or any other device, program and
                    methodology to continuously and automatically search, scrape,
                    extract, deep-link, index and/or disrupt the working of the
                    Platform and/or download large amount of data is not permitted
                    unless expressly permitted through API’s by Us.
                  </li>
                </ol>
              </li>
              <li>
                <p>Allowed Usage</p>
                <ol class="list">
                  <li>
                    <span>11.1.</span>Use for Internal Business Operations: The
                    Services and Content may only be used for the purposes of
                    Subscriber’s internal business operations. An Authorized User
                    may view, download, and manipulate the Content for
                    Subscriber’s internal business operations.
                  </li>
                  <li>
                    <span>11.2.</span>Use of Content: Authorized Users may
                    incorporate data from the Content (as “Work Product”) so long
                    as (A) the quantity of data incorporated from the Content into
                    the Work Product has no independent commercial value and is
                    not separately marketable by us; (B) the Work Product is not
                    issued on behalf of a third party; (C) the Work Product is not
                    published to more than 500 individuals without Our prior
                    written consent which consent will not be unreasonably
                    withheld; and (D) the incorporated Content contains the
                    following source attribution: Source: .........”relevant link
                    of Platform”............. We retain sole ownership over any
                    Content incorporated into the Work Product. If We assist the
                    Subscriber in the creation of Work Product, the Subscriber may
                    be charged additional fees as agreed to in writing by Us and
                    Subscriber in a separate Order.
                  </li>
                  <li>
                    <span>11.3.</span>Printing & Downloading: An Authorized User
                    may print or download and store the amount of Content
                    authorized in the Order only. However, the Subscriber may not
                    use such printing and downloading to compile more than an
                    insubstantial portion of Our database.
                  </li>
                  <li>
                    <span>11.4.</span>Subscribers with Advance and Premium
                    subscriptions can access data for up to 50 companies per day.
                    If a user attempts to access data for more than 50 companies
                    in a single day, their subscription will be temporarily
                    blocked for 24 hours.
                  </li>
                  <li>
                    <span>11.5.</span> For Advance Plan subscribers, there are 15
                    requests allowed for New Company Additions, whereas Premium
                    Plan subscribers enjoy the flexibility of submitting up to 30
                    requests for New Company Additions.<br/>In order to serve you
                    better, we want to emphasize that we have a dedicated team
                    here at TheKredible responsible for promptly processing all
                    requests. We want to assure you that your requests are
                    important to us, and we are committed to taking swift action
                    to meet your needs.
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Restrictions on Your Use of the Platform: Your use of the
                  Service is subject to the following additional restrictions:
                </p>
                <ol class="list">
                  <li><span>12.1.</span>No Uses Competitive with Us</li>
                  <li>
                    <span>12.2.</span>You agree not to use the Platform in any
                    manner, or its Content in furtherance of a Competitive
                    Product. A “Competitive Product” is a product or service that
                    provides customers with data that is substantially or
                    reasonably similar to data marketed and licensed by Us at of
                    the Effective Date. The Content may not be used for any
                    competitive analysis of how Our products and services compare
                    to a Competitive Product being offered or developed by
                    Subscriber.
                  </li>
                  <li>
                    <span>12.3.</span>Limitation on Distribution: Except as
                    explicitly allowed herein or the terms of an Order, Subscriber
                    may not transfer, sell, rent, distribute, display, or
                    otherwise disclose any portion of the Platform, Services,
                    Site, Content, or Applications to anyone.
                  </li>
                  <li>
                    <span>12.4.</span>You will not use the Content in conjunction
                    with any machine learning, neural network, deep learning,
                    predictive analytics, or other artificial intelligence
                    computer or software program. If the Subscriber collects data
                    from the Site in violation of this document, the Subscriber
                    agrees to promptly, upon receipt of invoice, delete such data
                    and pay 150% of the then-current direct data pricing for such
                    data or any other sum our accounting deems fit.
                  </li>
                  <li>
                    <span>12.5.</span>Unauthorized Access: Subscriber may
                    not-—through hacking, password mining, or any other
                    means—violate the security of the Site or any Application or
                    attempt to gain unauthorized access to the site, Content, or
                    Our computer systems. Authorized Users may not share their
                    password or other login credentials to the Services.
                  </li>
                  <li>
                    <span>12.6.</span>No Violations of Third-Party Intellectual
                    Property: Subscriber may not use the Site, Services, or any
                    Content in a manner that infringes or violates Our
                    intellectual property or proprietary rights or any third
                    party, including, without limitation, the rights of privacy
                    and publicity.
                  </li>
                  <li>
                    <span>12.7.</span>No Use in Third-Party Databases: Subscriber
                    may not input any Content into a customer relationship
                    management application or any other third-party database.
                  </li>
                  <li>
                    <span>12.8.</span>No Use in Violation of Laws: Subscriber may
                    not use the Site or Content in any manner that is unlawful or
                    that harms Us. Additionally, Subscriber may not use the Site
                    or Content in any way that is fraudulent, false, or deceptive.
                  </li>
                  <li>
                    <span>12.9.</span>No Offering of Securities: Subscriber may
                    not use the Services, Site, or Applications in such a way as
                    to be deemed to be engaging in the offering or solicitation of
                    investments in securities or to be using the Services, Site,
                    or Applications for any other improper investment purposes.
                  </li>
                  <li>
                    <span>12.10.</span>No Use for Credit or Employment
                    Eligibility: Subscriber may not use the Content as a factor in
                    establishing an individual’s eligibility for employment, or
                    for credit or insurance to be used primarily for personal,
                    family, or household purposes.
                  </li>
                  <li>
                    <span>12.11.</span>Intellectual Property Marks: Subscriber
                    must not remove or obscure the copyright, trademark, service
                    mark, or other notices contained on the Platform, Services,
                    Applications, or Content, regardless of whether such notices
                    relate to rights possessed by Us. Subscriber may not use Our
                    trademarks, service marks, logos, or other proprietary
                    identifiers, without prior written consent.
                  </li>
                  <li>
                    <span>12.12.</span>Professional Conduct: Subscriber must treat
                    Our employees and other Users on the Platform with a
                    reasonable level of cordiality and professionalism.
                  </li>
                  <li class="listinside">
                    <p class="d-flex">
                      <span>12.13</span>You represent, warrant, and agree that you
                      will not contribute or submit any User Submission (defined
                      below) or other materials or otherwise use the Service or
                      interact with the Service in a manner that:
                    </p>
                    <ol class="inside-list">
                      <li>
                        <span>12.13.1</span>Infringes or violates the intellectual
                        property rights or any other rights of anyone else
                        (including Ours);
                      </li>
                      <li>
                        <span>12.13.2</span>Violates any law or regulation,
                        including without limitation any applicable export control
                        laws and/or data privacy laws, or would cause Us to be in
                        violation of any law or regulation (including, without
                        limitation, any laws relating to labor, employment, or the
                        issuance of securities);
                      </li>
                      <li>
                        <span>12.13.3</span>Is harmful, fraudulent, deceptive,
                        threatening, harassing, defamatory, obscene, or otherwise
                        objectionable;
                      </li>
                      <li>
                        <span>12.13.4</span>Jeopardizes the security of your
                        account or anyone else’s (such as allowing someone else to
                        log in to the Service as you);
                      </li>
                      <li>
                        <span>12.13.5</span>Attempts, in any manner, to obtain the
                        password, account, or other security information from any
                        other user;
                      </li>
                      <li>
                        <span>12.13.6</span>Violates the security of any computer
                        network, or cracks any passwords or security encryption
                        codes;
                      </li>
                      <li>
                        <span>12.13.7</span>Runs any form of auto-responder or
                        “spam” on the Service, or any processes that run or are
                        activated while you are not logged into the Service, or
                        that otherwise interfere with the proper working of the
                        Service (including by placing an unreasonable load on the
                        Service infrastructure);
                      </li>
                      <li>
                        <span>12.13.8</span>“Crawls,” “scrapes,” or “spiders” any
                        page, data, or portion of or relating to the Service or
                        Content (through use of manual or automated means);
                      </li>
                      <li>
                        <span>12.13.9</span>Circumvents or attempts to circumvent
                        any features, limitations, or restrictions of the Service
                        (including, without limitation, attempting to access,
                        download, export, or otherwise use or exploit any Content
                        using any automated means or tools);
                      </li>
                      <li>
                        <span>12.13.10</span>Copies or stores any significant
                        portion of the Content;
                      </li>
                      <li>
                        <span>12.13.11</span>Decompiles, reverse engineers or
                        otherwise attempts to obtain the source code or underlying
                        ideas or information of or relating to the Service.
                      </li>
                      <li>
                        <span>12.13.12</span>No Technological Attacks or Scraping;
                        may not use or attempt to use any deep-link, scraper,
                        robot, bot, spider, data mining, computer code or any
                        other device, program, tool, algorithm, process or
                        methodology to systematically access, acquire, copy, or
                        monitor any portion of the Content or Site.
                      </li>
                    </ol>
                  </li>
                </ol>
                <p class="disc">
                  A violation of any of the foregoing is grounds for account
                  suspension or termination of your right to use or access the
                  Platform and/or Our Service.
                </p>
              </li>
              <li>
                <p>Stopping use of Service:</p>
                <ol class="list">
                  <li>
                    <span>13.1.</span>You’re free to do that at any time; please
                    refer our Privacy Policy, as well as the licenses above, to
                    understand how we treat information you provide to us after
                    you have stopped using our Service.
                  </li>
                  <li>
                    <span>13.2.</span>We are also free to terminate (or suspend
                    access to) your use of the Service or your account, for any
                    reason in our discretion, including your breach of these
                    Terms.
                  </li>
                  <li>
                    <span>13.3.</span>We have the sole right to decide whether you
                    are in violation of any of the restrictions set forth in these
                    Terms.
                  </li>
                  <li>
                    <span>13.4.</span>Account termination may result in the
                    destruction of any Content associated with your account, so
                    keep that in mind before you decide to terminate your account.
                    Provisions that, by their nature, should survive termination
                    of these Terms shall survive termination.
                  </li>
                  <li>
                    <span>13.5.</span>By way of example, all of the following will
                    survive termination: any obligation you have to pay us or
                    indemnify us, any limitations on our liability, any terms
                    regarding ownership or intellectual property rights, and terms
                    regarding disputes between us.
                  </li>
                  <li>
                    <span>13.6.</span>Additionally, upon termination of your
                    account We may require you to expunge some or all of the
                    Content in your possession, and you will do so promptly.
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Term:
                  <span
                    >This Agreement will commence on the Effective Date and will
                    terminate at the end of a trial or if no Order is in effect.
                    If a new Order is agreed to after the termination of this
                    Agreement, this Agreement will be reinstated unless otherwise
                    agreed.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Termination:
                  <span
                    >Termination for Breach: We may terminate this Agreement if
                    you breach this Agreement.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Effect of Termination:
                  <span
                    >Upon termination of this Agreement, you must promptly expunge
                    any Content you have in your possession and immediately
                    discontinue use of the Services, Site, Applications, and
                    Content. Sections will survive the termination of this
                    Agreement.</span
                  >
                </p>
              </li>
              <li>
                <p>Platform “As Is” and Disclaimer:</p>
                <ol class="list">
                  <li>
                    <span>17.1.</span>The Platform is provided on an “As Is” basis
                    without warranties of any kind. We make no representation or
                    warranty, either express or implied, regarding the adequacy,
                    completeness, usefulness and accuracy of the Platform. You
                    shall exercise your discretion while using the Platform or the
                    content therein.
                  </li>
                  <li>
                    <span>17.2.</span>Nothing contained in the Platform shall
                    constitute or should be construed as a solicitation, offer or
                    recommendation by Us.
                  </li>
                  <li>
                    <span>17.3.</span>We accept no liability for any errors or
                    omissions, with respect to any information provided to you
                    whether on behalf of itself or third parties.
                  </li>
                  <li>
                    <span>17.4.</span>The Platform is for educational and
                    information purposes only and not intended to provide any
                    financial, investment or legal advice. You shall seek the help
                    of a professional in pursuing such advice. Any article,
                    publication, statement, report, information, data or content
                    available on the Platform or on any link to the Platform will
                    not be sought as an advice or opinion from Us.
                  </li>
                </ol>
              </li>
              <li>
                <p>Confidentiality</p>
                <ol class="list">
                  <li>
                    <span>18.1.</span>The parties acknowledge that they shall
                    receive information belonging to the other party that can be
                    reasonably construed to be confidential and privileged
                    information not intended to be disclosed to any third parties
                    or other party, unless it needs to be disclosed for the
                    fulfillment of these Terms.
                  </li>
                  <li>
                    <span>18.2.</span>The parties agree to use reasonable
                    standards of care to keep such information confidential.
                    Nothing contained herein shall affect the ability of the
                    parties to make disclosures mandated by applicable laws.
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Indemnification:
                  <span
                    >The Subscriber will defend and indemnify Us from any
                    third-party claims, costs, reasonable attorneys’ fees,
                    damages, or other liabilities that arise out of Subscriber’s
                    unauthorized use or disclosure of the Site, Services,
                    Applications, or Content. For the purposes of this Section
                    “We” or “Us” includes all and any directors, officers,
                    employees, or agents.</span
                  >
                </p>
              </li>
              <li>
                <p>Warranty Disclaimer.</p>
                <ol class="list">
                  <li>
                    <span>20.1.</span>Neither Us nor Our licensors or suppliers
                    makes any representations or warranties concerning the Service
                    or any Content contained in or accessed through the Service,
                    and we will not be responsible or liable for the accuracy,
                    copyright compliance, legality, or decency of any materials
                    (including Content) contained in or accessed through the
                    Service.
                  </li>
                  <li>
                    <span>20.2.</span>We (and our licensors and suppliers) make no
                    representations or warranties regarding suggestions or
                    recommendations of services or products offered or purchased
                    through the Service. Products and services purchased or
                    offered (whether or not following such recommendations and
                    suggestions) through the Service are provided “AS IS” and
                    without any warranty of any kind from Us or others (unless,
                    with respect to such others only, provided expressly and
                    unambiguously in writing by a designated third-party for a
                    specific product).
                  </li>
                  <li>
                    <span>20.3.</span>THE SERVICE AND CONTENT ARE PROVIDED BY US
                    (AND ITS LICENSORS AND SUPPLIERS) ON AN “AS-IS” BASIS, WITHOUT
                    WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING,
                    WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY,
                    ACCURACY, AVAILABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                    NON-INFRINGEMENT, OR THAT USE OF THE SERVICE WILL BE
                    UNINTERRUPTED OR ERROR-FREE. SOME STATES DO NOT ALLOW
                    LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE
                    ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
                  </li>
                </ol>
              </li>
              <li>
                <p>Limitation of Liability.</p>
                <ol class="list">
                  <li>
                    <span>21.1.</span>TO THE FULLEST EXTENT ALLOWED BY APPLICABLE
                    LAW, UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY
                    (INCLUDING, WITHOUT LIMITATION, TORT, NEGLIGENCE, CONTRACT,
                    STRICT LIABILITY, OR OTHERWISE) SHALL WE (OR ITS LICENSORS OR
                    SUPPLIERS) BE LIABLE TO YOU OR TO ANY OTHER PERSON FOR (A) ANY
                    INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY
                    KIND, INCLUDING DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL,
                    WORK STOPPAGE, ACCURACY OF RESULTS, COST OF PROCUREMENT OF
                    SUBSTITUTE GOODS OR SERVICES, OR COMPUTER FAILURE OR
                    MALFUNCTION, OR (B) ANY AMOUNT, IN THE AGGREGATE, IN EXCESS OF
                    THE GREATER OF (I) 10,000/- OR (II) THE AMOUNTS PAID BY YOU TO
                    US IN CONNECTION WITH THE SERVICE IN THE TWELVE (12) MONTH
                    PERIOD PRECEDING THE APPLICABLE CLAIM, OR (C) ANY MATTER
                    BEYOND OUR REASONABLE CONTROL. SOME STATES DO NOT ALLOW THE
                    EXCLUSION OR LIMITATION OF CERTAIN DAMAGES, SO THE ABOVE
                    LIMITATION AND EXCLUSIONS MAY NOT APPLY TO YOU.
                  </li>
                </ol>
              </li>
              <li>
                <p>Assignment:</p>
                <ol class="list">
                  <li>
                    <span>22.1.</span>You may not assign, delegate or transfer
                    these Terms or your rights or obligations hereunder, or your
                    Service account, in any way (by operation of law or otherwise)
                    without Our prior written consent.
                  </li>
                  <li>
                    <span>22.2.</span>We may transfer, assign, or delegate these
                    Terms and our rights and obligations without consent.
                  </li>
                </ol>
              </li>
              <li>
                <p>Choice of Law; Arbitration.</p>
                <ol class="list">
                  <li>
                    <span>23.1.</span>These Terms are governed by and will be
                    construed under the laws of India, without regard to the
                    conflicts of laws provisions thereof. Any dispute arising from
                    or relating to the subject matter of these Terms (whether
                    brought against Us or against any director, officer or
                    employee in their personal capacity) shall be finally settled
                    in Gurgaon, in English, in accordance with the Arbitration and
                    Conciliation Act then in effect, by one arbitrator with
                    substantial experience in resolving intellectual property and
                    commercial contract disputes, who shall be selected by Us.
                  </li>
                  <li>
                    <span>23.2.</span>Judgment upon the award rendered by such
                    arbitrator may be entered in any court of competent
                    jurisdiction. Notwithstanding the foregoing obligation to
                    arbitrate disputes, each party shall have the right to pursue
                    injunctive or other equitable relief at any time, from any
                    court of competent jurisdiction.
                  </li>
                  <li>
                    <span>23.3.</span>For all purposes of these Terms, the parties
                    consent to exclusive jurisdiction and venue in Gurgaon. Any
                    arbitration under these Terms will take place on an individual
                    basis: class arbitrations and class actions are not permitted.
                  </li>
                </ol>
              </li>
              <li>
                <p>Safe Harbor Statement.</p>
                <ol class="list">
                  <li>
                    <span>24.1.</span>Any statements made by Us, oral or written,
                    about new Service features or functionality are intended to
                    outline Our general product direction for information purposes
                    only and are not a commitment to deliver any material,
                    applications, or functionality, and should not be relied upon.
                    The development, release, and timing of any features or
                    functionality remains at Our sole discretion.
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Waiver -
                  <span
                    >No forbearance, inaction or delay by Us in exercising any
                    right under these Terms shall be construed as a waiver or
                    acquiescence of that right.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Severability -
                  <span
                    >If any provision of these Terms is found invalid or
                    unenforceable to any extent, the remaining terms of these
                    Terms shall not be affected thereby and remain in full force
                    and effect to the maximum extent permitted by law.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Modifications -
                  <span
                    >These Terms may be revised from time to time by Us in order
                    to improve the Platform or in conformity with regulatory
                    requirements. By continuing to use Our Platform after we have
                    revised these Terms, you agree to be bound by the revised
                    Terms.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Availability -
                  <span
                    >We shall not be held responsible for non-availability of the
                    Platform during periodic maintenance operations or any
                    unplanned suspension of access to the Platform that may occur
                    due to any reason beyond Our control.</span
                  >
                </p>
              </li>
              <li>
                <p>
                  Force Majeure -
                  <span
                    >Neither parties will be liable for any inadequate performance
                    of their obligations under these Terms, for reasons beyond
                    their control (i.e., War, Government legislations, accidents,
                    floods, etc.</span
                  >
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
